import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Apply from './pages/Apply';
import RecruiterSignup from './pages/RecruiterSignup';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import RecruiterLogin from './pages/RecruiterLogin';
import RecruiterDashboard from './pages/RecruiterDashboard';
import RecruiterForgotPassword from './pages/RecruiterForgotPassword';
import RecruiterResetPassword from './pages/RecruiterResetPassword';
import AdminForgotPassword from './pages/AdminForgotPassword';
import AdminResetPassword from './pages/AdminResetPassword';
import DomesticApplicationForm from './pages/DomesticApplicationForm';
import { Toaster } from './components/ui/toaster';
import { getToken, getRole } from './lib/api';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function RequireAdmin({ children }) {
  if (!getToken() || getRole() !== 'admin') return <Navigate to="/admin-login" replace />;
  return children;
}

function RequireRecruiter({ children }) {
  if (!getToken() || getRole() !== 'recruiter') return <Navigate to="/recruiter/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/domestic" element={<DomesticApplicationForm />} />
          <Route path="/recruiter-signup" element={<RecruiterSignup />} />
          <Route path="/admin-login" element={<Login />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/recruiter/login" element={<RecruiterLogin />} />
          <Route path="/recruiter/forgot-password" element={<RecruiterForgotPassword />} />
          <Route path="/recruiter/reset-password" element={<RecruiterResetPassword />} />
          <Route path="/recruiter" element={<RequireRecruiter><RecruiterDashboard /></RequireRecruiter>} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
